import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import type { FunctionComponent } from 'react';
import { Fragment, useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import { MainHeadlineSubPage } from '../../../design/components/Typography';
import { TalentTabs } from './TalentTabs';

const Headline: FunctionComponent = () => {
    const { translate } = useContext(ApplicationContext);

    return (
        <Grid alignContent="center" container={true} sx={{ pb: 3, pt: 6 }}>
            <Container>
                <MainHeadlineSubPage>{translate('pages.talent-directory.title')}</MainHeadlineSubPage>
            </Container>
        </Grid>
    );
};

export const TalentDirectoryPage: FunctionComponent = () => (
    <Fragment>
        <Headline />
        <Container>
            <TalentTabs />
        </Container>
    </Fragment>
);
